import api from '../../../utils/functions/api';

import {
  PROMOTION_WITH_WHOLESALE_ALL,
  PROMOTION_WITH_WHOLESALE_CREATE,
  PROMOTION_WITH_WHOLESALE_GET,
  PROMOTION_WITH_WHOLESALE_UPDATE,
  PROMOTION_WITH_WHOLESALE_DELETE,
  PROMOTION_WITH_WHOLESALE_ERROR,
} from '../types';

// faker.locale = "th"

export const getAllPromotionWithWholesale = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/promotion-wholesale?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PROMOTION_WITH_WHOLESALE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PROMOTION_WITH_WHOLESALE_ERROR });
    throw new Error(error);
  }
};

export const getOnePromotionWithWholesale = (id) => async (dispatch) => {
  await api
    .get(`${process.env.REACT_APP_API_URL}/promotion-wholesale/${id}`)
    .then((res) => {
      console.log('Request Server to Get One option');
      if (res.data) {
        dispatch({ type: PROMOTION_WITH_WHOLESALE_GET, payload: res.data });
      } else {
        dispatch({ type: PROMOTION_WITH_WHOLESALE_GET, payload: null });
      }
    });
};
export const createOnePromotionWithWholesale = (payload) => async (
  dispatch,
) => {
  await api
    .post(`${process.env.REACT_APP_API_URL}/promotion-wholesale/`, payload)
    .then(() => {
      console.log('Request Server to Create New option');
      dispatch({ type: PROMOTION_WITH_WHOLESALE_CREATE });
    });
};

export const editOnePromotionWithWholesale = (id, payload) => async (
  dispatch,
) => {
  await api
    .put(`${process.env.REACT_APP_API_URL}/promotion-wholesale/${id}`, payload)
    .then(() => {
      console.log('Request Server to edit option');
      dispatch({ type: PROMOTION_WITH_WHOLESALE_UPDATE });
    });
};

export const deleteOnePromotionWithWholesale = (id) => async (dispatch) => {
  await api
    .delete(`${process.env.REACT_APP_API_URL}/promotion-wholesale/${id}`)
    .then(() => {
      console.log('Request Server to Delete One option');
      dispatch({ type: PROMOTION_WITH_WHOLESALE_DELETE, payload: null });
    });
};
